import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ApiService } from '../utils/api';
import { formatCurrency } from '../utils/currency';

const CouponDetailPage = () => {
  const { couponId } = useParams();
  const { data: coupon } = useQuery({
    queryKey: ['coupon', couponId],
    queryFn: () => ApiService.getCoupon(couponId),
    enabled: !!couponId,
  });
  const { data: redemptionsResponse, isLoading } = useQuery({
    queryKey: ['couponRedemptions', couponId],
    queryFn: () => ApiService.getCouponRedemptions(couponId, 0, 100),
    enabled: !!couponId,
  });
  const redemptions = Array.isArray(redemptionsResponse?.content) ? redemptionsResponse.content : [];

  return (
    <div className="p-6 space-y-4">
      <Link to="/admin/settings/coupons" className="text-sm text-blue-600">← Coupons</Link>
      <h1 className="text-2xl font-bold">{coupon?.code || 'Coupon usage'}</h1>
      <Card>
        <CardHeader><CardTitle>Redemptions</CardTitle></CardHeader>
        <CardContent className="p-0">
          {isLoading ? (
            <p className="p-4 text-sm text-gray-500">Loading…</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-left">
                <tr>
                  <th className="p-3">Email</th>
                  <th className="p-3">Event</th>
                  <th className="p-3">Registration</th>
                  <th className="p-3">Original</th>
                  <th className="p-3">Discount</th>
                  <th className="p-3">Paid</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">When</th>
                </tr>
              </thead>
              <tbody>
                {redemptions.map((row) => (
                  <tr key={row.id} className="border-t">
                    <td className="p-3">{row.email}</td>
                    <td className="p-3">{row.eventName || row.eventId}</td>
                    <td className="p-3">{row.registrationUserId || '—'}</td>
                    <td className="p-3">{formatCurrency(row.originalAmount)}</td>
                    <td className="p-3">{formatCurrency(row.discountAmount)}</td>
                    <td className="p-3">{formatCurrency(row.finalAmount)}</td>
                    <td className="p-3">{row.status}{row.releaseReason ? ` (${row.releaseReason})` : ''}</td>
                    <td className="p-3">{row.confirmedAt || row.reservedAt || row.releasedAt}</td>
                  </tr>
                ))}
                {redemptions.length === 0 && (
                  <tr><td className="p-4 text-gray-500" colSpan={8}>No usage yet</td></tr>
                )}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CouponDetailPage;
